// 其他信息
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let email = get(state, 'currentContractorDetail.contractorInfo.extraInfo.email', {})
  return {
    title: i18n.gettext('审批邮件'),
    content: [
      {
        title: i18n.gettext('附件说明'),
        label: email.desc
      },
      {
        title: i18n.gettext('附件照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: email.pics
      }
      // {
      //   title: i18n.gettext('附件文件'),
      //   content: i18n.gettext('查看'),
      //   isLink: true,
      //   arrow: true,
      //   pics: email.files
      // }
    ]
  }
}
